import { createBrowserRouter } from "react-router-dom";
import AppLayout from "./components/Layout";
import Bookings from "./pages/Bookings/Index";
import Categories from "./pages/Categories/Index";
import Cities from "./pages/Cities/Index";
import Events from "./pages/Events";
import NewEvent from "./pages/Events/NewEvent";
import Login from "./pages/Login";
import Offers from "./pages/Offers/Index";
import NewEventOffer from "./pages/Offers/NewOffer/NewEventOffer";
import NewSpecialOffer from "./pages/Offers/NewOffer/NewSpecialOffer";
import NewTourOffer from "./pages/Offers/NewOffer/NewTourOffer";
import UpdateOffer from "./pages/Offers/UpdateOffer";
import Partners from "./pages/Partners";
import Places from "./pages/Places";
import NewPlace from "./pages/Places/NewPlace";
import PlaceUpdateOffer from "./pages/Places/PlaceOffers/PlaceUpdateOffer";
import Home from "./pages/home";
import AllUsers from "./pages/users";
import { FormMode } from "./helpers/enums";
import Compte from "./pages/Compte";
import Change from "./pages/Compte/change";
import Drivers from "./pages/Drivers";
import { DriverSessionsList } from "./pages/Drivers/Activities";
import Driver from "./pages/Drivers/Driver";
import UploadDocument from "./pages/Drivers/UploadDocument";
import PendingDrivers from "./pages/Drivers/pending";
import ErrorPage from "./pages/ErrorPage";
import Event from "./pages/Events/Event";
import EventServices from "./pages/Events/EventServices";
import EventNewService from "./pages/Events/EventServices/EventNewService";
import EventStatistics from "./pages/Events/EventStatistics";
import OrganizeEvents from "./pages/Events/OrganizeEvents";
import EventReservation from "./pages/Events/reservations";
import Inspectors from "./pages/Inspectors";
import PlaceAdminInvoicesPage from "./pages/Invoices/InvoicesPage";
import InvoicesPage from "./pages/Invoices";
import Newsletter from "./pages/Newsletter";
import NotFound from "./pages/NotFound";
import Notifications from "./pages/Notifications";
import NewNotification from "./pages/Notifications/NewNotification";
import OrganizeOffers from "./pages/Offers/OrganizeOffers";
import Packs from "./pages/Packs";
import NewPack from "./pages/Packs/NewPack";
import Payouts from "./pages/Payouts";
import FloorPlanner from "./pages/Places/FloorPlanner";
import Place from "./pages/Places/Place";
import PlaceGallery from "./pages/Places/PlaceGallery";
import PlaceInspectors from "./pages/Places/PlaceInspectors";
import PlaceNewInspector from "./pages/Places/PlaceInspectors/PlaceNewInspector";
import PlaceUpdateInspector from "./pages/Places/PlaceInspectors/PlaceUpdateInspector";
import PlaceOffers from "./pages/Places/PlaceOffers";
import PlaceNewOffer from "./pages/Places/PlaceOffers/PlaceNewOffer";
import PlaceReviews from "./pages/Places/PlaceReviews";
import PlaceServices from "./pages/Places/PlaceServices";
import PlaceNewService from "./pages/Places/PlaceServices/PlaceNewService";
import ServiceCategories from "./pages/ServicesCategories";
import Translations from "./pages/Translations";
import NewCategoryTranslation from "./pages/Translations/Categories/NewCategoryTranslation";
import NewEventTranslation from "./pages/Translations/Events/NewEventTranslation";
import NewPackTranslation from "./pages/Translations/Packs/NewPackTranslation";
import NewPlaceTranslation from "./pages/Translations/Places/NewPlaceTranslation";
import NewServiceCategoryTranslation from "./pages/Translations/ServiceCategories/NewServiceCategoryTranslation";
import NewServiceTranslation from "./pages/Translations/Services/NewServiceTranslation";
import NewSpecialTranslation from "./pages/Translations/Specials/NewSpecialTranslation";
import NewServiceSubCategoryTranslation from "./pages/Translations/serviceSubCategory/AddServiceSubCategory";
import Variables from "./pages/Variables";
import WhatsappMessages from "./pages/WhatsappMessages";
import Publicite from "./pages/advertisement";
import NewPublicite from "./pages/advertisement/NewAdvertisement";
import PromoCodes from "./pages/promoCode";
import AddNewPromoCode from "./pages/promoCode/AddNewPromoCode";
import UpdatePromoCode from "./pages/promoCode/UpdatePromoCode";
import Statistics from "./pages/statistics";
import AllTaxi from "./pages/taxi/AllTaxi";
import Riders from "./pages/taxi/Riders";
import TaxiDiscounts from "./pages/taxi/discounts";
import { CouponDetails } from "./pages/taxi/discounts/details";
import CreateTaxiDiscount from "./pages/taxi/discounts/new";
import UpdateDiscount from "./pages/taxi/discounts/update";
import RideConversations from "./pages/taxi/rides/conversations";
import RideDetailsPage from "./pages/taxi/rides/ridesdetails";
import TransactionsPage from "./pages/transactions";
import UserDetailPage from "./pages/users/user";
import VenezSettings from "./pages/VenezSettings";
import PlaceAdminPartners from "./pages/placeAdminPartners";
import PlaceManagerActivities from "./pages/place-manager/activities/activities";
import PlaceManagerBookings from "./pages/place-manager/bookings/bookings";
import PlaceManagerPercentage from "./pages/place-manager/percentage";
import PlaceManagerOfferBooking from "./pages/place-manager/activities/booking";
import { QRCodesPage } from "./pages/placeAdminPartners/QRCodes";
import { NewInvoicePage } from "./pages/multi-place-admin/invoices/new/NewInvoicePage";
import { InvoiceDetailsPage } from "./pages/multi-place-admin/invoices/details/InvoiceDetailsPage";
import PartnerStatisticsPage from "./pages/placeAdminPartners/PartnerStatisticsPage";
import SpecialPercentages from "./pages/placeAdminPartners/SpecialPercentages";
import TaxiSpecialZones from "./pages/taxi/specialZones";
import CreateTaxiSpecialZone from "./pages/taxi/specialZones/new/inex";
import RewardsPage from "./pages/reward";
import AddNewReward from "./pages/reward/AddNewReward";
import NewRewardTranslation from "./pages/Translations/Rewards/NewRewardsTranslation";
import NewActivity from "./pages/activities/newActivity";
import Activities from "./pages/activities";
import OrganizeActivities from "./pages/activities/OrganizeActivities";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/home",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    element: <AppLayout />,
    index: false,
    children: [
      {
        path: "/users",
        element: <AllUsers />,
      },
      { path: "/users/:id", element: <UserDetailPage /> },
      {
        path: "/places",
        element: <Places />,
      },
      {
        path: "/place-admin-partners",
        element: <PlaceAdminPartners />,
      },
      {
        path: "/places/:placeId",
        element: <Place />,
      },
      {
        path: "/places/:placeId/offers",
        element: <PlaceOffers />,
      },
      {
        path: "/places/:placeId/services",
        element: <PlaceServices />,
      },
      {
        path: "/places/:placeId/inspectors",
        element: <PlaceInspectors />,
      },
      {
        path: "/places/:placeId/gallery",
        element: <PlaceGallery />,
      },
      {
        path: "/places/:placeId/ratings",
        element: <PlaceReviews />,
      },
      {
        path: "/newsletter",
        element: <Newsletter />,
      },
      {
        path: "/inspectors",
        element: <Inspectors />,
      },
      { path: "/invoices", element: <InvoicesPage /> },
      {
        path: "/invoices/new/:invoiceDate/:partnerId",
        element: <NewInvoicePage />,
      },
      {
        path: "/invoices/details/:invoiceId",
        element: <InvoiceDetailsPage />,
      },

      { path: "/offer/update/:id", element: <PlaceUpdateOffer /> },

      { path: "/places/:id/planner", element: <FloorPlanner /> },
      {
        path: "/service/update/:id",
        element: <PlaceNewService mode={FormMode.UPDATE} />,
      },
      { path: "/places/:placeId/offer/new", element: <PlaceNewOffer /> },
      { path: "/places/:placeId/services/new", element: <PlaceNewService /> },
      {
        path: "/places/:placeId/inspectors/new",
        element: <PlaceNewInspector />,
      },
      {
        path: "/places/:placeId/inspectors/:inspectorId/update",
        element: <PlaceUpdateInspector />,
      },
      {
        path: "/places/:placeId/invoices",
        element: <PlaceAdminInvoicesPage />,
      },

      {
        path: "/events/:eventId",
        element: <Event />,
      },
      {
        path: "/events/:eventId/services",
        element: <EventServices />,
      },
      { path: "/events/:eventId/reservation", element: <EventReservation /> },
      {
        path: "/events/:eventId/services/new",
        element: <EventNewService mode={FormMode.CREATE} />,
      },
      {
        path: "/events/:eventId/statistics",
        element: <EventStatistics />,
      },
      {
        path: "/events/:eventId/services/:serviceId/update",
        element: <EventNewService mode={FormMode.UPDATE} />,
      },

      {
        path: "/places/update/:id",
        element: <NewPlace mode={FormMode.UPDATE} />,
      },
      { path: "/events", element: <Events /> },
      { path: "/events/new", element: <NewEvent mode={FormMode.CREATE} /> },
      {
        path: "/events/update/:id",
        element: <NewEvent mode={FormMode.UPDATE} />,
      },

      {
        path: "/events/duplicate/:id",
        element: <NewEvent mode={FormMode.DUPLICATE} />,
      },
      { path: "/events/organize", element: <OrganizeEvents /> },

      { path: "/categories", element: <Categories /> },

      // * Service Categories Routes
      { path: "/service-categories", element: <ServiceCategories /> },

      { path: "/notifications", element: <Notifications /> },
      { path: "/notifications/new", element: <NewNotification /> },
      { path: "//whatsapp-messages", element: <WhatsappMessages /> },
      { path: "//drivers", element: <Drivers /> },
      { path: "//Sessions", element: <DriverSessionsList /> },

      { path: "/demandes", element: <PendingDrivers /> },
      { path: "/drivers/:driverId", element: <Driver /> },
      { path: "/drivers/:driverId/upload-files", element: <UploadDocument /> },
      { path: "/rides", element: <Riders /> },
      { path: "/rides/:rideId/conversations", element: <RideConversations /> },
      { path: "/rides/:rideId/ridedetails", element: <RideDetailsPage /> },

      { path: "/taxi", element: <AllTaxi /> },
      { path: "/taxi/discounts", element: <TaxiDiscounts /> },
      { path: "/taxi/discounts/new", element: <CreateTaxiDiscount /> },
      { path: "/taxi/discounts/update/:id", element: <UpdateDiscount /> },
      { path: "/taxi/discounts/:id", element: <CouponDetails /> },
      { path: "/taxi/special-zones", element: <TaxiSpecialZones /> },
      {
        path: "/taxi/special-zones/new",
        element: <CreateTaxiSpecialZone mode="create" />,
      },
      {
        path: "/taxi/special-zones/update/:id",
        element: <CreateTaxiSpecialZone mode="update" />,
      },
      // { path: "//drivers/:driverId/conversations", element: <Conversations /> },
      { path: "/whatsapp-messages", element: <WhatsappMessages /> },
      // { path: "/drivers", element: <Drivers /> },
      // { path: "/drivers/:driverId", element: <Driver /> },
      { path: "/bookings", element: <Bookings /> },
      { path: "/offers", element: <Offers /> },
      { path: "/offers/organize", element: <OrganizeOffers /> },
      { path: "/offers/update/:id", element: <UpdateOffer /> },
      { path: "/offers/percentages/:offerId", element: <SpecialPercentages /> },
      { path: "/offers/new/special-offer", element: <NewSpecialOffer /> },
      { path: "/offers/new/event-offer", element: <NewEventOffer /> },
      { path: "/offers/new/tour-offer", element: <NewTourOffer /> },
      {
        path: "/offers/update/special-offer/:id",
        element: <NewSpecialOffer mode={FormMode.UPDATE} />,
      },
      {
        path: "/offers/update/event-offer/:id",
        element: <NewEventOffer mode={FormMode.UPDATE} />,
      },
      {
        path: "/offers/update/tour-offer/:id",
        element: <NewTourOffer mode={FormMode.UPDATE} />,
      },
      { path: "/packs", element: <Packs /> },
      { path: "/packs/new", element: <NewPack /> },
      {
        path: "/packs/update/:id",
        element: <NewPack mode={FormMode.UPDATE} />,
      },
      { path: "/places/new", element: <NewPlace /> },
      { path: "/partners", element: <Partners /> },
      { path: "/cities", element: <Cities /> },
      { path: "/compte", element: <Compte /> },
      { path: "/change", element: <Change /> },
      { path: "/variables", element: <Variables /> },
      {
        path: "/payouts",
        element: <Payouts />,
      },
      {
        path: "/translations",
        element: <Translations />,
      },
      {
        path: "/promo-codes",
        element: <PromoCodes />,
      },
      {
        path: "/promo-codes/new",
        element: <AddNewPromoCode />,
      },
      {
        path: "/promo-codes/:id/edit",
        element: <UpdatePromoCode />,
      },
      {
        path: "/promo-codes/:id/event",
        element: <PromoCodes view="events" />,
      },
      {
        path: "/rewards",
        element: <RewardsPage />,
      },
      { path: "/rewards/new", element: <AddNewReward mode="create" /> },
      { path: "/rewards/:id", element: <AddNewReward mode="edit" /> },
      {
        path: "/advertisement",
        element: <Publicite />,
      },
      {
        path: "/advertisement/new",
        element: <NewPublicite />,
      },
      {
        path: "/advertisement/update/:id",
        element: <NewPublicite mode={FormMode.UPDATE} />,
      },
      {
        path: "/place-translations/update/:id",
        element: <NewPlaceTranslation mode={FormMode.UPDATE} />,
      },
      { path: "/place-translations/new", element: <NewPlaceTranslation /> },
      {
        path: "/event-translations/update/:id",
        element: <NewEventTranslation mode={FormMode.UPDATE} />,
      },
      { path: "/event-translations/new", element: <NewEventTranslation /> },
      {
        path: "/special-translations/update/:id",
        element: <NewSpecialTranslation mode={FormMode.UPDATE} />,
      },
      { path: "/special-translations/new", element: <NewSpecialTranslation /> },
      {
        path: "/category-translations/update/:id",
        element: <NewCategoryTranslation mode={FormMode.UPDATE} />,
      },
      {
        path: "/category-translations/new",
        element: <NewCategoryTranslation />,
      },
      {
        path: "/service-translations/update/:id",
        element: <NewServiceTranslation mode={FormMode.UPDATE} />,
      },
      { path: "/service-translations/new", element: <NewServiceTranslation /> },
      {
        path: "/pack-translations/update/:id",
        element: <NewPackTranslation mode={FormMode.UPDATE} />,
      },
      { path: "/pack-translations/new", element: <NewPackTranslation /> },
      {
        path: "/service-category-translations/update/:id",
        element: <NewServiceCategoryTranslation mode={FormMode.UPDATE} />,
      },
      {
        path: "/service-category-translations/new",
        element: <NewServiceCategoryTranslation />,
      },
      {
        path: "/service-sub-category-translations/update/:id",
        element: <NewServiceSubCategoryTranslation mode={FormMode.UPDATE} />,
      },
      {
        path: "/service-sub-category-translations/new",
        element: <NewServiceSubCategoryTranslation />,
      },
      {
        path: "/rewards-translations/update/:id",
        element: <NewRewardTranslation mode={FormMode.UPDATE} />,
      },
      {
        path: "/reward-translations/new",
        element: <NewRewardTranslation />,
      },

      {
        path: "/rewards/:id",
        element: <AddNewReward mode="edit" />,
      },
      {
        path: "/transactions",
        element: <TransactionsPage />,
      },
      {
        path: "/statistics",
        element: <Statistics />,
      },
      { path: "/settings", element: <VenezSettings /> },
      // * Place Manager Routes
      {
        path: "/place-manager/activities",
        element: <PlaceManagerActivities />,
      },
      {
        path: "/place-manager/activities/booking/:id",
        element: <PlaceManagerOfferBooking />,
      },
      {
        path: "/place-manager/bookings",
        element: <PlaceManagerBookings />,
      },
      {
        path: "/place-manager/commission",
        element: <PlaceManagerPercentage />,
      },
      {
        path: "/place-manager/activities/booking/:id",
        element: <PlaceManagerOfferBooking />,
      },
      // {
      //   path: "/place-manager/bookings",
      //   element: <PlaceManagerBookings />,
      // },
      {
        path: "/place-manager/commission",
        element: <PlaceManagerPercentage />,
      },
      {
        path: "/place-admin-partners/qr-codes/place/",
        element: <QRCodesPage visiteType="place" />,
      },
      {
        path: "/place-admin-partners/:partnerId/statistics",
        element: <PartnerStatisticsPage />,
      },
      {
        path: "/place-admin-partners/qr-codes/offer/:offerId",
        element: <QRCodesPage visiteType="offer" />,
      },
      {
        path: "/activities",
        element: <Activities />,
      },
      {
        path: "/activities/new",
        element: <NewActivity mode={FormMode.CREATE} />,
      },
      {
        path: "/activities/update/:id",
        element: <NewActivity mode={FormMode.UPDATE} />,
      },
      {
        path: "/activities/organize",
        element: <OrganizeActivities />,
      },
      {},
    ],
    errorElement: <ErrorPage />,
  },
]);

export default router;
